import { api, ApiError } from '@/services/api';
import type { WpSite, WpSiteCreate, WpSiteTestResult } from '@/types/config';

export { ApiError };

export const onboardingApi = {
  createSite: (data: WpSiteCreate): Promise<WpSite> => api.post<WpSite>('/config/sites', data),

  testSite: (siteId: string): Promise<WpSiteTestResult> =>
    api.post<WpSiteTestResult>(`/config/sites/${siteId}/test`),
};
